export default __webpack_public_path__ + "86b74e8c16fb05c87e2edbe6ff1ea86e.webp";